import { Table, Text } from '@mantine/core';

import { paymentTypes } from '../../types';

type BodyRowProps = {
  payment: paymentTypes.Payment;
};

export const BodyRow = ({ payment }: BodyRowProps) => {
  const { amount, currency, client_details, payment_method, date, source } = payment;

  return (
    <Table.Tr>
      <Table.Td>
        <Text size="sm">{amount}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{currency}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{client_details}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{payment_method}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{date}</Text>
      </Table.Td>
      <Table.Td>
        <Text size="sm">{source}</Text>
      </Table.Td>
    </Table.Tr>
  );
};
